var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.options)?_c('FullCalendar',{ref:"fullCalendar",attrs:{"options":_vm.options}}):_vm._e(),_c('q-inner-loading',{staticStyle:{"z-index":"9999"},attrs:{"showing":_vm.isLoading}},[_c('q-spinner-ios',{attrs:{"size":"70px","color":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }